import type { UnlikelyProduct } from "@unlikelystudio/commerce-connector"

export function productHasStockAlert(product: UnlikelyProduct): boolean {
  return product.tags.map((tag) => tag.toUpperCase()).indexOf("NO_RESTOCK") === -1
}
